import {
  CreateDIV,
  MouseActionType,
  createElement,
  CreateForm,
  CreateImage,
  CreateHeading,
  CreateInputButton,
  CreateInputFile,
  CreateInputText,
  CreateInputCheck,
  CreateInputHidden,
  CreateSPAN,
  CreateP,
  CreateLabel,
  CreateSelect,
  CreateOption,
  CreateInputRadio,
  CreateTextArea,
  CreateUL,
  CreateLI,
} from '../HTML';
import flatpickr from 'flatpickr';
import {
  get_language,
  getCookie,
  getLanguageString,
  xdr,
  getTop,
} from '../common';

import { websession } from '../websession';
import { lang } from '../language';
// **** COMPONENTS
const Components = window.Components ?? {};

// **** DIALOG
/**
 * @namespace Components.Dialog
 */
Components.Dialog = window.Components.Dialog ?? {};

/**
 * Modal dialog (V2)
 * @class ModalDialogV2
 * @description Create a Modal dialog (version 2)
 * @memberof Components.Dialog
 * @param {object} Owner - HTML DOM element
 * @param {object} SlideData - Slide data
 * @param {object} ResultSlide - Result slide data
 */
export function ModalDialogV2(Owner, SlideData, ResultSlide) {
  var _self = this;

  this.owner = Owner;
  this.slides = [];
  this.resultSlide = null;
  this.Function = null;
  this.slideObjects = [];

  // DISABLE BODY SCROLLBAR
  document.body.style.overflowY = 'hidden';

  // MAKE OVERLAY
  this.divDialog = CreateDIV(Owner, null, null, 'openModal');
  this.divDialog.style.opacity = 1;
  this.divDialog.style.pointerEvents = 'auto';

  // *** DIALOG CONTENT CONTAINER
  var divDialogContent = CreateDIV(this.divDialog, 'dialog wm');

  // *** CREATE RESPONSE CONTAINER (OPTIONAL)
  if (ResultSlide !== null && ResultSlide !== undefined) {
    this.createResponseSlide(divDialogContent, ResultSlide);
  }

  // *** CONTENT WRAPPER CONTAINER
  this.divContentWrapper = CreateDIV(divDialogContent, 'wm-content-wrapper');

  // *** SLIDES
  var slideIndex = 0;
  SlideData.forEach(function (sd) {
    var cssHideSlide = slideIndex > 0 ? 'hidden-slide' : '';
    var slide = new Components.Dialog.ModalDialogSlide(
      _self,
      _self.divContentWrapper,
      cssHideSlide,
      sd,
      slideIndex,
      SlideData.length
    );
    _self.slides.push(slide);

    slideIndex++;
  });
}
Components.Dialog.ModalDialogV2 = ModalDialogV2;

/**
 * Create response slide
 * @param {object} Owner - HTML dom element
 * @param {object} ResultSlide - Result slide data
 * @method createResponseSlide
 * @memberof Components.Dialog.ModalDialogV2#
 */
ModalDialogV2.prototype.createResponseSlide = function (Owner, ResultSlide) {
  var _self = this;

  // RESPONSE SLIDE CONTAINER
  var divResponseSlide = CreateDIV(
    Owner,
    'wm-response-slide',
    'display: none;'
  );
  var divResponseImage = CreateDIV(divResponseSlide, 'wm-response-image');
  CreateImage(divResponseImage, ResultSlide.Image.Url);

  // TITLE
  var divResponseTitle = CreateDIV(divResponseSlide, 'wm-response-title');
  CreateHeading(divResponseTitle, 2, null, ResultSlide.Text.Title);
  CreateP(divResponseTitle, 2, ResultSlide.Text.Subtitle);

  // BUTTON
  var divResponseButton = CreateDIV(divResponseSlide, 'wm-response-btn');
  CreateInputButton(
    divResponseButton,
    'green',
    function (a, e) {
      if (a === MouseActionType.Click) {
        if (ResultSlide.Button.ButtonFunction !== undefined) {
          ResultSlide.Button.ButtonFunction();
          _self.close();
        } else {
          _self.close();
        }
      }
    },
    ResultSlide.Button.ButtonText
  );

  this.resultSlide = divResponseSlide;
};
/**
 * Create confirmation modal
 * @param {object} Owner - HTML dom element
 * @param {string} TitleText - Title text
 * @param {string} ButtonConfirmText - Confirm button text
 * @param {string} ButtonCancelText - Cancel button text
 * @callback [Callback] - Callback function after clicking confirm button (optional)
 * @method createConfirmModal
 * @memberof Components.Dialog.ModalDialogV2#
 */
ModalDialogV2.prototype.createConfirmModal = function (
  TitleText,
  ButtonConfirmText,
  ButtonCancelText,
  Callback
) {
  var _self = this;

  // CONTAINER DIV
  this.divConfirm = CreateDIV(
    this.divContentWrapper,
    'in-modal-confirmation',
    'display: block;'
  );
  var divIMC = CreateDIV(this.divConfirm, 'imc-card');

  // TITLE
  CreateHeading(divIMC, 2, null, TitleText);

  // CONFIRM BUTTON
  this.inpSaveButton = CreateInputButton(
    divIMC,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        if (Callback !== null && Callback !== undefined) {
          Callback();
        }
      }
    },
    ButtonConfirmText
  );

  // CANCEL BUTTON
  var inpCancelButton = CreateInputButton(
    divIMC,
    'grey',
    function (a, e) {
      if (a === MouseActionType.Click) {
        _self.divConfirm.style.display = 'none';
      }
    },
    ButtonCancelText
  );
  inpCancelButton.focus();
};
/**
 * Create alert modal
 * @param {object} Owner - HTML dom element
 * @param {string} TitleText - Title text
 * @param {string} ParagraphText - Paragraph text
 * @param {string} ButtonText - Confirm button text
 * @method createAlertModal
 * @memberof Components.Dialog.ModalDialogV2#
 */
ModalDialogV2.prototype.createAlertModal = function (
  TitleText,
  ParagraphText,
  ButtonText
) {
  var _self = this;

  // CONTAINER DIV
  this.divAlert = CreateDIV(
    this.divContentWrapper,
    'in-modal-confirmation',
    'display: block;'
  );
  var divIMC = CreateDIV(this.divAlert, 'imc-card');

  // TITLE
  CreateHeading(divIMC, 2, null, TitleText);

  // PARAGRAPH
  CreateP(divIMC, null, ParagraphText);

  // CONFIRM BUTTON
  this.inpSaveButton = CreateInputButton(
    divIMC,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        _self.divAlert.parentElement.removeChild(_self.divAlert);
      }
    },
    ButtonText
  );
  this.inpSaveButton.focus();
};
/**
 * Close modal
 * @method close
 * @memberof Components.Dialog.ModalDialogV2#
 */
ModalDialogV2.prototype.close = function () {
  // IF MODAL EXISTS, CLOSE MODAL
  if (this.divDialog.parentElement) {
    // ENABLE BODY SCROLLBAR
    document.body.style.overflowY = 'visible';
    // HIDE POPUP
    this.divDialog.parentElement.removeChild(this.divDialog);
  }
};

/**
 * Modal dialog slide
 * @class ModalDialogSlide
 * @description Create a Modal dialog (version 2) slide
 * @memberof Components.Dialog
 * @param {Components.Dialog.ModalDialogV2} Modal - Modal dialog the slide is placed on
 * @param {object} Owner - HTML DOM element
 * @param {string} [CSSClass] - CSS class
 * @param {object} SlideData - Elements which must be placed on de slide
 * @param {number} SlideIndex - Index of current slide
 * @param {number} SlidesTotal - Total number of slides
 */
export function ModalDialogSlide(
  Modal,
  Owner,
  CSSClass,
  SlideData,
  SlideIndex,
  SlidesTotal
) {
  var _self = this;
  this.modal = Modal;
  this.slideIndex = SlideIndex;

  // CONTAINER
  this.divSlide = CreateDIV(Owner, 'wm-slide');
  if (CSSClass !== '') {
    this.divSlide.classList.add(CSSClass);
  }

  // CLOSE BUTTON
  var divSlideClose = CreateDIV(
    this.divSlide,
    'close-rm',
    null,
    null,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        Modal.close();
      }
    }
  );
  createElement('i', divSlideClose, 'fa fa-times');

  // LOOP THROUGH SLIDE ELEMENTS
  SlideData.forEach(function (sd) {
    // TITLE
    if (sd.Title !== undefined) {
      _self.divSlide.appendChild(sd.Title.container);
    }

    // SUB TITLE
    if (sd.SubTitle !== undefined) {
      _self.divSlide.appendChild(sd.SubTitle.container);
    }

    // LABEL
    if (sd.Label !== undefined) {
      _self.divSlide.appendChild(sd.Label.container);
    }

    // SELECT
    if (sd.Select !== undefined) {
      _self.divSlide.appendChild(sd.Select.container);
    }

    // TEXTAREA
    if (sd.TextArea !== undefined) {
      _self.divSlide.appendChild(sd.TextArea.container);
    }

    // INPUT
    if (sd.Input !== undefined) {
      _self.divSlide.appendChild(sd.Input.container);
    }

    // EDIT LIST INPUT
    if (sd.EditListInput !== undefined) {
      sd.EditListInput.setSlide(_self);
      _self.divSlide.appendChild(sd.EditListInput.container);
    }

    // MULTI SELECT
    if (sd.MultiSelect !== undefined) {
      _self.divSlide.appendChild(sd.MultiSelect.container);
    }

    // MULTI SELECT WITH ADD
    if (sd.MultiSelectAdd !== undefined) {
      _self.divSlide.appendChild(sd.MultiSelectAdd.container);
    }

    // ADD INPUT
    if (sd.AddInput !== undefined) {
      _self.divSlide.appendChild(sd.AddInput.container);
    }

    // CHECKBOX LABEL
    if (sd.CheckboxLabel !== undefined) {
      _self.divSlide.appendChild(sd.CheckboxLabel.container);
    }

    // COURSE URL'S
    if (sd.CourseUrls !== undefined) {
      _self.divSlide.appendChild(sd.CourseUrls.divMainContainer);
    }

    // REMOTE SCORM SLIDER
    if (sd.RSSlider !== undefined) {
      _self.divSlide.appendChild(sd.RSSlider.container);
    }

    // SEARCH BOX
    if (sd.SearchBox !== undefined) {
      _self.divSlide.appendChild(sd.SearchBox.container);
    }

    // CHECK BOX
    if (sd.CheckBox !== undefined) {
      _self.divSlide.appendChild(sd.CheckBox.container);
    }

    //IMAGE UPLOAD
    if (sd.ImageUpload !== undefined) {
      _self.divSlide.appendChild(sd.ImageUpload.container);
    }

    // DATE SELECTOR
    if (sd.DatePicker !== undefined) {
      _self.divSlide.appendChild(sd.DatePicker.container);
    }

    // LIST
    if (sd.List !== undefined) {
      _self.divSlide.appendChild(sd.List.container);
    }

    // LIST DOUBLE ROW
    if (sd.ListDoubleRow !== undefined) {
      _self.divSlide.appendChild(sd.ListDoubleRow.container);
    }

    // BUTTON(S)
    if (sd.Buttons !== undefined) {
      // BUTTONS AND LOCATORS
      var divButtonsAndLocators = CreateDIV(
        _self.divSlide,
        'wm-btns-and-locater'
      );

      // ONLY 1 SLIDE
      if (SlidesTotal === 1) {
        var btnSingle = CreateInputButton(
          divButtonsAndLocators,
          'green',
          function (a, e) {
            if (a === MouseActionType.Click) {
              sd.Buttons.Button2Function();
            }
          },
          sd.Buttons.Button2Text
        );
        btnSingle.style.cssText = 'float: none; margin: 0px auto; width: auto;';
      }
      // MULTIPLE SLIDES
      else {
        var cssNotVisible = SlideIndex === 0 ? 'not-visible' : '';
        CreateInputButton(
          divButtonsAndLocators,
          'grey ' + cssNotVisible,
          function (a, e) {
            if (a === MouseActionType.Click) {
              _self.showPrevious();
            }
          },
          sd.Buttons.Button1Text
        );

        if (_self.slideIndex < SlidesTotal - 1) {
          CreateInputButton(
            divButtonsAndLocators,
            null,
            function (a, e) {
              if (a === MouseActionType.Click) {
                var resultButton2Function = true;
                if (sd.Buttons.Button2Function !== undefined) {
                  resultButton2Function = sd.Buttons.Button2Function();
                }
                if (resultButton2Function) {
                  _self.showNext();
                }
              }
            },
            sd.Buttons.Button2Text
          );
        } else {
          CreateInputButton(
            divButtonsAndLocators,
            'green',
            function (a, e) {
              if (a === MouseActionType.Click) {
                sd.Buttons.Button2Function();
              }
            },
            sd.Buttons.Button2Text
          );
        }
      }

      // LOCATER CONTAINER
      var divLocatorsContainer = CreateDIV(
        divButtonsAndLocators,
        'wm-locaters'
      );

      // NUMBER OF SLIDES > 1
      if (SlidesTotal > 1) {
        const divLocatorsCenter = CreateDIV(
          divLocatorsContainer,
          'wm-locater-middle'
        );

        for (var i = 0; i < SlidesTotal; i++) {
          var cssPresentStep = SlideIndex >= i ? 'present-step' : '';
          var divLocator = CreateDIV(divLocatorsCenter, 'wm-locater');
          if (cssPresentStep !== '') divLocator.classList.add(cssPresentStep);
          divLocator.style.width = 'calc(166px / ' + SlidesTotal + ')';
        }
      }
      // 1 SLIDE
      else {
        divLocatorsContainer.style.margin = '33px 0 5px 0';
      }
    }
  });
}
Components.Dialog.ModalDialogSlide = ModalDialogSlide;

/**
 * Show next slide
 * @method showNext
 * @memberof Components.Dialog.ModalDialogSlide#
 */
ModalDialogSlide.prototype.showNext = function () {
  var _self = this;

  if (_self.slideIndex < _self.modal.slides.length - 1) {
    _self.modal.slides[_self.slideIndex].hide();
    _self.modal.slides[_self.slideIndex + 1].show();
  }
};
/**
 * Show previous slide
 * @method showPrevious
 * @memberof Components.Dialog.ModalDialogSlide#
 */
ModalDialogSlide.prototype.showPrevious = function () {
  var _self = this;

  if (_self.slideIndex > 0) {
    _self.modal.slides[_self.slideIndex].hide();
    _self.modal.slides[_self.slideIndex - 1].show();
  }
};
/**
 * Hide slide
 * @method hide
 * @memberof Components.Dialog.ModalDialogSlide#
 */
ModalDialogSlide.prototype.hide = function () {
  this.divSlide.style.display = 'none';
};
/**
 * Show slide
 * @method show
 * @memberof Components.Dialog.ModalDialogSlide#
 */
ModalDialogSlide.prototype.show = function () {
  this.divSlide.style.display = 'block';
};

/**
 * @description Create popup form
 * @class FormDialog
 * @memberof Components.Dialog
 * @param {object} Owner - HTML DOM element
 * @param {object} FormData - Form data
 * @callback Function - Callback function
 */
export function FormDialog(Owner, FormData, Function) {
  var _self = this;

  this.owner = Owner;
  this.formElements = [];
  var requiredCount = 0;
  // GENERAL FORM VALUES
  var id = FormData.Id;

  // JSON DATA
  var jsonData = JSON.parse(FormData.Json);
  var optIn = FormData.Optin;
  var optInData = {};
  var txtData = {};
  var txtPostData = {};

  // LOOP THROUGH JSON DATA
  for (var i = 0; i < jsonData.length; i++) {
    if (jsonData[i].LanguageCode === '') {
      optInData.Text = jsonData[i].OptInTxt;
      optInData.LinkText = jsonData[i].OptInLinkTxt;
      optInData.LinkUrl = jsonData[i].OptInLinkUrl;

      txtData.Title = jsonData[i].Title;
      txtData.SubTitle = jsonData[i].SubTitle;
      txtData.Description = jsonData[i].Description;
      txtData.ButtonText = jsonData[i].ButtonTxt;

      txtPostData.Title = jsonData[i].PostTitle;
      txtPostData.SubTitle = jsonData[i].PostSubTitle;
      txtPostData.Description = jsonData[i].PostDescription;
      txtPostData.ButtonText = jsonData[i].PostButtonTxt;
    }
    if (jsonData[i].LanguageCode === get_language()) {
      optInData.Text = jsonData[i].OptInTxt;
      optInData.LinkText = jsonData[i].OptInLinkTxt;
      optInData.LinkUrl = jsonData[i].OptInLinkUrl;

      txtData.Title = jsonData[i].Title;
      txtData.SubTitle = jsonData[i].SubTitle;
      txtData.Description = jsonData[i].Description;
      txtData.ButtonText = jsonData[i].ButtonTxt;

      txtPostData.Title = jsonData[i].PostTitle;
      txtPostData.SubTitle = jsonData[i].PostSubTitle;
      txtPostData.Description = jsonData[i].PostDescription;
      txtPostData.ButtonText = jsonData[i].PostButtonTxt;
      break;
    }
  }

  // DISABLE BODY SCROLLBAR
  document.body.style.overflowY = 'hidden';

  // MODAL CONTAINER
  this.divOpenModal = CreateDIV(
    Owner,
    null,
    'opacity: 1; pointer-events: auto;',
    'openModal'
  );

  // FORM CONTAINER
  var divFormContainer = CreateDIV(this.divOpenModal, 'dialog form-modal');

  // *** RESULT SCREEN
  this.divResult = CreateDIV(
    divFormContainer,
    'wm-response-slide',
    'display: none;'
  );

  // IMAGE
  var divImage = CreateDIV(this.divResult, 'wm-response-image');
  CreateImage(divImage, '/img/invite-process-2.svg');

  // TEXT
  var divText = CreateDIV(this.divResult, 'wm-response-title');
  CreateHeading(divText, 2, null, txtPostData.Title);
  CreateP(divText, null, txtPostData.Description);

  // BUTTON
  var divButton = CreateDIV(this.divResult, 'wm-response-btn');
  CreateInputButton(
    divButton,
    'green',
    function (a, e) {
      if (a === MouseActionType.Click) {
        _self.close();
      }
    },
    txtPostData.ButtonText
  );

  // *** FORM SCREEN
  this.divForm = CreateDIV(divFormContainer, 'wm-content-wrapper');

  // INFO SCREEN
  this.divInfo = CreateDIV(
    this.divForm,
    'in-modal-confirmation',
    'display: none;'
  );
  var divCard = CreateDIV(this.divInfo, 'imc-card');
  this.divTitleAlert = CreateHeading(
    divCard,
    2,
    null,
    lang.generic.frm_dlg_txt_title
  );
  this.divDescriptionAlert = CreateP(
    divCard,
    null,
    lang.generic.frm_dlg_txt_fields_incorrect
  );
  CreateInputButton(
    divCard,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        _self.divInfo.style.display = 'none';
      }
    },
    lang.generic.frm_dlg_btn_fields_incorrect
  );

  // SLIDE
  var divSlide = CreateDIV(this.divForm, 'wm-slide');

  // CLOSE BUTTON
  var divClose = CreateDIV(
    divSlide,
    'close-rm',
    null,
    null,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        _self.close();
      }
    }
  );
  createElement('i', divClose, 'fa fa-times');

  // LIGHT GREY TITLE
  CreateDIV(divSlide, 'wm-lightgrey-title');

  // TITLE
  CreateDIV(divSlide, 'wm-title', null, null, txtData.Title);

  // SUBTITLE
  CreateDIV(divSlide, 'fm-subtitle', null, null, txtData.SubTitle);

  // PARAGRAPH
  CreateDIV(divSlide, 'fm-paragraph', null, null, txtData.Description);

  // FORM ELEMENTS CONTAINER
  var divFormElements = CreateDIV(divSlide, 'fm-elements');

  // FORM
  var frmForm = CreateForm(divFormElements, 'post');
  FormData.Element.forEach(function (e) {
    var formElement = {
      Id: e.Name + '_' + e.FormId,
      Name: e.Name,
      Type: e.ElementType,
      Validation: e.Validation,
    };

    if (e.Validation !== 'none') {
      requiredCount++;
    }

    _self.formElements.push(formElement);
    switch (e.ElementType) {
      case 'hidden':
      case 'text':
        _self.addInput(frmForm, e.ElementType, e);
        break;
      case 'select':
        _self.addSelect(frmForm, e);
        break;
      case 'radio':
        _self.addRadio(frmForm, e);
        break;
      case 'textarea':
        _self.addTextArea(frmForm, e);
        break;
      case 'checkbox':
        _self.addCheckbox(frmForm, e);
        break;
    }
  });

  // REQUIRED FIELDS NOTIFICATION
  if (requiredCount > 0) {
    CreateDIV(
      frmForm,
      'note',
      null,
      null,
      lang.generic.frm_txt_fields_required
    );
  }

  // UTMS COOKIE DATA
  var UTMSCookie = getCookie('utms');
  if (UTMSCookie !== '') {
    var utmsData = JSON.parse(UTMSCookie);

    // PLACE UTMS DATA IN HIDDEN FIELDS
    for (var key in utmsData) {
      var obj = utmsData[key];

      let formElement = {
        Id: key + '_' + id,
        Name: key,
        Type: 'hidden',
        Validation: 'none',
      };

      var elementData = {
        Name: key,
        ElementType: 'hidden',
        DefaultValue: obj,
        FormId: id,
      };

      this.formElements.push(formElement);
      this.addInput(frmForm, 'hidden', elementData);
    }
  }

  var divButtonContainer = CreateDIV(divSlide, 'fm-cb');
  // SHOW OPTIN MESSAGE
  if (optIn) {
    let formElement = {
      Id: 'FixedOptIn' + '_' + id,
      Name: 'FixedOptIn',
      Type: 'fixedoptin',
      Validation: 'fixedoptin',
    };
    this.formElements.push(formElement);

    var lblOptIn = CreateLabel(divButtonContainer, 'checkbox');
    CreateInputCheck(
      lblOptIn,
      null,
      null,
      null,
      null,
      'FixedOptIn',
      'FixedOptIn_' + id
    );
    CreateSPAN(lblOptIn);

    CreateDIV(
      divButtonContainer,
      'next-to-checkbox',
      null,
      null,
      optInData.Text.replace(
        optInData.LinkText,
        "<a href='" +
          optInData.LinkUrl +
          " ' target='_blank'>" +
          optInData.LinkText +
          '</a>'
      )
    );
  }

  // ADD BUTTON
  this.addButton(divSlide, getLanguageString(txtData.ButtonText), Function);

  // PUBLIC PROPERTIES
  this.Id = function () {
    return id;
  };
}
Components.Dialog.FormDialog = FormDialog;

FormDialog.prototype = {
  constructor: FormDialog,
  /**
   * Close popup
   * @method close
   * @memberof Components.Dialog.FormDialog#
   */
  close: function () {
    if (this.divOpenModal.parentElement) {
      // ENABLE BODY SCROLLBAR
      document.body.style.overflowY = 'auto';
      // CLOSE MODAL
      this.divOpenModal.parentElement.removeChild(this.divOpenModal);
    }
  },
  /**
   * Set the text of the alert dialog
   * @method setAlertText
   * @memberof Components.Dialog.FormDialog#
   */
  setAlertText: function (Title, Description) {
    this.divTitleAlert.innerHTML = Title;
    this.divDescriptionAlert.innerHTML = Description;
  },
  /**
   * Add a HTML input button element to the form
   * @param {object} Owner - HTML dom element
   * @param {string} Value - Text on button
   * @param {string} Function - Deprecated: 25-10-2018
   * @returns {object} - HTML input button element
   * @method addButton
   * @memberof Components.Dialog.FormDialog#
   */
  addButton: function (Owner, Value, Function) {
    var _self = this;

    // BUTTON AND LOCATERS
    var divButtonAndLocaters = CreateDIV(Owner, 'wm-btns-and-locater');

    // BUTTON
    var btnButton = CreateInputButton(
      divButtonAndLocaters,
      'green',
      function (a, e) {
        if (a === MouseActionType.Click) {
          var errCount = 0;
          var corporateEmailOK = true;
          // VALIDATION OF FORM
          for (var i = 0; i < _self.formElements.length; i++) {
            switch (_self.formElements[i].Validation) {
              case 'required':
              case 'phone':
                if (
                  _self.formElements[i].Type === 'text' ||
                  _self.formElements[i].Type === 'textarea'
                ) {
                  if (
                    document.getElementById(_self.formElements[i].Id).value ===
                    ''
                  ) {
                    errCount++;
                  }
                } else if (_self.formElements[i].Type === 'radio') {
                  var rbChecked = false;
                  var tmpData = document.getElementsByName(
                    _self.formElements[i].Name
                  );
                  for (var j = 0; j < tmpData.length; j++) {
                    if (tmpData[j].checked) {
                      rbChecked = true;
                      break;
                    }
                  }
                  if (!rbChecked) {
                    errCount++;
                  }
                } else if (_self.formElements[i].Type === 'checkbox') {
                  var cbChecked = false;
                  var tmpData = document.getElementsByName(
                    _self.formElements[i].Name
                  );
                  for (var j = 0; j < tmpData.length; j++) {
                    if (tmpData[j].checked) {
                      cbChecked = true;
                      break;
                    }
                  }
                  if (!cbChecked) {
                    errCount++;
                  }
                }
                break;
              case 'email':
                if (
                  document.getElementById(_self.formElements[i].Id).value !==
                    '' &&
                  !_self.validateEmail(
                    document.getElementById(_self.formElements[i].Id).value
                  )
                ) {
                  errCount++;
                } else if (
                  document.getElementById(_self.formElements[i].Id).value === ''
                ) {
                  errCount++;
                }
                break;
              case 'corporate-email':
                var regExpNonCorporateEmailDomains =
                  /^[a-zA-Z0-9'_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(gmail|outlook|hotmail|yahoo|aol|msn|live|gmx|web)\.(.*)$/g;
                if (
                  document.getElementById(_self.formElements[i].Id).value ===
                    '' ||
                  !_self.validateEmail(
                    document.getElementById(_self.formElements[i].Id).value
                  )
                ) {
                  errCount++;
                } else if (
                  document
                    .getElementById(_self.formElements[i].Id)
                    .value.match(regExpNonCorporateEmailDomains) !== null
                ) {
                  corporateEmailOK = false;
                }
                break;
              default:
                break;
            }
          }

          // ERRORS FOUND
          if (errCount > 0) {
            _self.setAlertText(
              lang.generic.frm_dlg_txt_title,
              lang.generic.frm_dlg_txt_fields_incorrect
            );
            _self.divInfo.style.display = 'block';
            _self.divOpenModal.scrollTo(0, 0);
          } else {
            if (!corporateEmailOK) {
              _self.setAlertText(
                lang.generic.frm_dlg_txt_title,
                lang.generic.frm_dlg_txt_corp_email_incorrect
              );
              _self.divInfo.style.display = 'block';
              _self.divOpenModal.scrollTo(0, 0);
            } else {
              var o;
              var data = [];

              // FORM ID
              o = { Name: 'FormId', Value: _self.Id().toString() };
              data.push(o);

              // FORM FIELDS
              for (let i = 0; i < _self.formElements.length; i++) {
                switch (_self.formElements[i].Type) {
                  case 'hidden':
                  case 'text':
                  case 'textarea':
                    o = {
                      Name: _self.formElements[i].Name,
                      Value: document
                        .getElementById(_self.formElements[i].Id)
                        .value.toString(),
                    };
                    break;
                  case 'fixedoptin':
                    var checked = document.getElementById(
                      _self.formElements[i].Id
                    ).checked
                      ? 1
                      : 0;
                    o = {
                      Name: _self.formElements[i].Name,
                      Value: checked,
                    };
                    break;
                  case 'checkbox':
                    var cbCheckedData = [];
                    var tmpData = document.getElementsByName(
                      _self.formElements[i].Name
                    );
                    for (var j = 0; j < tmpData.length; j++) {
                      if (tmpData[j].checked) {
                        cbCheckedData.push(tmpData[j].value);
                      }
                    }

                    o = {
                      Name: _self.formElements[i].Name,
                      Value: cbCheckedData,
                    };
                    break;
                  case 'radio':
                    var rbCheckedData = '';
                    var tmpData = document.getElementsByName(
                      _self.formElements[i].Name
                    );
                    for (var j = 0; j < tmpData.length; j++) {
                      if (tmpData[j].checked) {
                        rbCheckedData = tmpData[j].value;
                      }
                    }

                    o = {
                      Name: _self.formElements[i].Name,
                      Value: rbCheckedData,
                    };
                    break;
                  case 'select':
                    o = {
                      Name: _self.formElements[i].Name,
                      Value: document
                        .getElementById(_self.formElements[i].Id)
                        .value.toString(),
                    };
                    break;
                  default:
                    break;
                }
                data.push(o);
              }
              //alert(data)
              var tmp = new Components.Dialog.ModalDialog(
                document.body,
                Components.Dialog.ModalDialogType.Busy,
                lang.generic.frm_please_wait,
                null,
                function () {
                  // SEND DATA
                  xdr(
                    ghapi + '/api/formsubmit/',
                    'POST',
                    JSON.stringify(data),
                    function (x) {
                      var d = JSON.parse(x);
                      if (d.Success) {
                        tmp.close();
                        _self.divForm.style.display = 'none';
                        _self.divResult.style.display = 'block';
                        //document.location = _self.SuccessUrl();
                      } else {
                        var msg = '';
                        switch (d.ErrorCode) {
                          case 101:
                            msg = lang.generic.frm_dlg_txt_error_101;
                            break;
                          case 102:
                            msg = lang.generic.frm_dlg_txt_error_102;
                            break;
                          case 103:
                            msg = lang.generic.frm_dlg_txt_error_103;
                            break;
                          default:
                            break;
                        }
                        tmp.close();
                        new Components.Dialog.ModalDialog(
                          document.body,
                          Components.Dialog.ModalDialogType.NotificationFail,
                          msg,
                          lang.generic.frm_btn_error
                        );
                      }
                    },
                    function (x) {
                      tmp.close();
                      new Components.Dialog.ModalDialog(
                        document.body,
                        Components.Dialog.ModalDialogType.NotificationFail,
                        lang.generic.err_dlg_text + x,
                        lang.generic.err_dlg_btn
                      );
                    }
                  );
                }
              );
            }
          }
        }
      },
      Value
    );
    btnButton.style.cssText =
      'margin-left:0; margin-right:0; float:none; margin:0 auto; width:auto;';

    // LOCATERS
    var divLocaters = CreateDIV(
      divButtonAndLocaters,
      'wm-locaters',
      'margin:33px 0 5px 0;'
    );
    CreateDIV(divLocaters, 'wm-locater-middle');
  },
  /**
   * Add a HTML input element (text/hidden)
   * @param {object} Owner - HTML dom element
   * @param {string} Type - Deprecated: 25-10-2018
   * @param {object} ElementData - Data of input element
   * @returns {object} - HTML input element
   * @method addInput
   * @memberof Components.Dialog.FormDialog#
   */
  addInput: function (Owner, Type, ElementData) {
    var _self = this;
    // CHECK PREFILL
    if (ElementData.DefaultValue) {
      var prefillValue = this.prefillText(ElementData.DefaultValue);
    } else {
      var prefillValue = '';
    }

    // ELEMENT
    if (ElementData.ElementType === 'text') {
      // LABEL
      var lblContainer = CreateLabel(
        Owner,
        'inp',
        ElementData.Name + '_' + ElementData.FormId
      );

      // INPUT FIELD
      var inputText = CreateInputText(
        lblContainer,
        'fm-input',
        null,
        null,
        null,
        prefillValue,
        ElementData.Name
      );

      inputText.id = ElementData.Name + '_' + ElementData.FormId;
      inputText.addEventListener('focus', function (a, e) {
        _self.floatLabel(inputText);
        inputText.placeholder = getLanguageString(ElementData.PlaceholderValue);
      });
      inputText.addEventListener('focusout', function (a, e) {
        _self.unfloatLabel(inputText);
        inputText.placeholder = '';
      });

      // INDICATOR IF ELEMENT IS REQUIRED
      var requiredText = ElementData.Validation !== 'none' ? ' *' : '';
      // LABEL
      CreateSPAN(
        lblContainer,
        'label',
        null,
        getLanguageString(ElementData.LabelValue) + requiredText
      );

      // BORDER
      CreateSPAN(lblContainer, 'border');

      // CHECK IF DEFAULT VALUE IS FILLED
      if (prefillValue !== '') {
        _self.floatLabel(inputText);
      }
    } else if (ElementData.ElementType === 'hidden') {
      var defaultValue = '';
      if (
        ElementData.Name === 'languagecode' &&
        ElementData.DefaultValue === ''
      ) {
        defaultValue = get_language();
      }
      var inputHidden = CreateInputHidden(
        Owner,
        ElementData.Name,
        defaultValue !== '' ? defaultValue : ElementData.DefaultValue
      );
      inputHidden.id = ElementData.Name + '_' + ElementData.FormId;
    }
  },
  /**
   * Add a HTML select element to the form
   * @param {object} Owner - HTML dom element
   * @param {object} ElementData - Data of input element
   * @returns {object} - HTML select element
   * @method addSelect
   * @memberof Components.Dialog.FormDialog#
   */
  addSelect: function (Owner, ElementData) {
    // LABEL
    var lblContainer = CreateLabel(
      Owner,
      'inp fm-select',
      ElementData.Name + '_' + ElementData.FormId
    );
    // ELEMENT
    var select = CreateSelect(
      lblContainer,
      null,
      null,
      null,
      null,
      ElementData.Name,
      ElementData.Name + '_' + ElementData.FormId
    );
    // OPTIONS
    ElementData.Option.sort(function (a, b) {
      return a.DisplayOrder - b.DisplayOrder;
    });

    ElementData.Option.forEach(function (o) {
      CreateOption(
        select,
        getLanguageString(o.Name),
        getLanguageString(o.Value)
      );
    });

    // INDICATOR IF ELEMENT IS REQUIRED
    var requiredText = ElementData.Validation !== 'none' ? ' *' : '';
    // LABEL
    CreateSPAN(
      lblContainer,
      'label-select',
      null,
      getLanguageString(ElementData.LabelValue) + requiredText
    );

    // BORDER
    CreateSPAN(lblContainer, 'border');
  },
  /**
   * Add a HTML input radio element to the form
   * @param {object} Owner - HTML DOM element
   * @param {object} ElementData - Data of input element
   * @returns {object} - HTML input radio element
   * @method addRadio
   * @memberof Components.Dialog.FormDialog#
   */
  addRadio: function (Owner, ElementData) {
    // LABEL
    var requiredText = ElementData.Validation !== 'none' ? ' *' : '';
    CreateDIV(
      Owner,
      'fm-label',
      null,
      null,
      getLanguageString(ElementData.LabelValue) + requiredText
    );

    // SORT OPTIONS
    ElementData.Option.sort(function (a, b) {
      return a.DisplayOrder - b.DisplayOrder;
    });

    // MAKE OPTIONS
    ElementData.Option.forEach(function (o) {
      // CONTAINER
      var divRBContainer = CreateDIV(Owner, 'fm-rb');
      var lblRB = CreateLabel(
        divRBContainer,
        'radio-btn',
        o.Name + '_' + ElementData.FormId
      );
      // RADIO BUTTON
      CreateInputRadio(
        lblRB,
        null,
        null,
        null,
        getLanguageString(o.Value),
        ElementData.Name,
        o.Name + '_' + ElementData.FormId
      );
      // SPAN
      CreateSPAN(lblRB, 'checkmark');

      // LABEL
      CreateDIV(
        divRBContainer,
        'next-to-checkbox',
        null,
        null,
        getLanguageString(o.Value)
      );
    });
  },
  /**
   * Add a HTML input checkbox element to the form
   * @param {object} Owner - HTML DOM element
   * @param {object} ElementData - Data of input element
   * @returns {object} - HTML input checkbox element
   * @method addCheckbox
   * @memberof Components.Dialog.FormDialog#
   */
  addCheckbox: function (Owner, ElementData) {
    // LABEL
    var requiredText = ElementData.Validation !== 'none' ? ' *' : '';
    CreateDIV(
      Owner,
      'fm-label',
      null,
      null,
      getLanguageString(ElementData.LabelValue) + requiredText
    );

    // SORT OPTIONS
    ElementData.Option.sort(function (a, b) {
      return a.DisplayOrder - b.DisplayOrder;
    });

    // MAKE OPTIONS
    ElementData.Option.forEach(function (o) {
      // CONTAINER
      var divCBContainer = CreateDIV(Owner, 'fm-cb');
      var lblCB = CreateLabel(
        divCBContainer,
        'checkbox',
        o.Name + '_' + ElementData.FormId
      );
      // CHECKBOX
      CreateInputCheck(
        lblCB,
        null,
        null,
        null,
        getLanguageString(o.Value),
        ElementData.Name,
        o.Name + '_' + ElementData.FormId
      ); //, ElementData.Name + "_" + ElementData.FormId);
      // SPAN
      CreateSPAN(lblCB);

      // LABEL
      CreateDIV(
        divCBContainer,
        'next-to-checkbox',
        null,
        null,
        getLanguageString(o.Value)
      );
    });
  },
  /**
   * Add a HTML textarea element to the form
   * @param {object} Owner - HTML DOM element
   * @param {object} ElementData - Data of input element
   * @returns {object} - HTML textarea element
   * @method addTextArea
   * @memberof Components.Dialog.FormDialog#
   */
  addTextArea: function (Owner, ElementData) {
    var _self = this;
    // LABEL
    var lblContainer = CreateLabel(
      Owner,
      'inp',
      ElementData.Name + '_' + ElementData.FormId
    );

    // TEXT AREA
    var txtRemark = CreateTextArea(
      lblContainer,
      'fm-input',
      null,
      null,
      ElementData.Name,
      ElementData.Name + '_' + ElementData.FormId,
      getLanguageString(ElementData.PlaceholderValue)
    );
    txtRemark.addEventListener('focus', function (a, e) {
      _self.floatLabel(txtRemark);
    });
    txtRemark.addEventListener('focusout', function (a, e) {
      _self.unfloatLabel(txtRemark);
    });

    // SPAN
    if (ElementData.LabelValue !== '') {
      var requiredText = ElementData.Validation !== 'none' ? ' *' : '';
      CreateSPAN(
        lblContainer,
        'label',
        null,
        getLanguageString(ElementData.LabelValue) + requiredText
      );
    }

    // BORDER
    CreateSPAN(lblContainer, 'border');
  },
  /**
   * Validate e-mail address
   * @param {string} value - E-mail address
   * @returns {bool} - E-mail address is valid
   * @method validateEmail
   * @memberof Components.Dialog.FormDialog#
   */
  validateEmail: function (value) {
    var mailformat =
      /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(\.?[a-zA-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@\w+([\.-]?\w+)*(\.\w{2,61})+$/;
    return value.match(mailformat);
  },
  /**
   * Return form container
   * @returns {object} - HTML div element
   * @method getContainer
   * @memberof Components.Dialog.FormDialog#
   */
  getContainer: function () {
    return this.divFormContainer;
  },
  /**
   * Float the input label
   * @method floatLabel
   * @memberof Components.Dialog.FormDialog#
   */
  floatLabel: function (Element) {
    Element.classList.add('focussed-border');
    Element.nextElementSibling.classList.add('focussed');
  },
  /**
   * Unfloat the input label
   * @method unfloatLabel
   * @memberof Components.Dialog.FormDialog#
   */
  unfloatLabel: function (Element) {
    if (Element.value === '') {
      Element.classList.remove('focussed-border');
      Element.nextElementSibling.classList.remove('focussed');
    } else {
      Element.classList.remove('focussed-border');
    }
  },
  /**
   * check if text can be prefilled with data from websession
   * @param {string} text - text to prefill
   * @method prefillText
   * @returns {string} - prefilled text
   * @memberof Components.Dialog.FormDialog#
   */
  prefillText: function (text) {
    var regExp = /\{([^)]+)\}/;
    var matches = regExp.exec(text);

    if (matches !== undefined) {
      const results = matches[1].split('.');
      if (results.shift() === 'websession') {
        text = this.getDescendantProp(websession, results);
      }
      if (text) {
        return text;
      } else {
        return '';
      }
    }
    return text === undefined ? '' : text;
  },
  /**
   * add descendant attributes to obj
   * @param {object} obj - object to add descendants to
   * @param {string} desc - list of descendants
   * @method getDescendantProp
   * @returns {object} - object with descendants
   * @memberof Components.Dialog.FormDialog#
   */
  getDescendantProp: function (obj, desc) {
    while (desc.length) {
      obj = obj[desc.shift()];
    }
    return obj;
  },
};
// **** OBJECTS
/**
 * @namespace Components.Dialog.Objects
 * @description Collection of objects used in dialog V2
 */
Components.Dialog.Objects = window.Components.Dialog.Objects ?? {};
/**
 * Title class
 * @class Title
 * @description Create a title on a slide
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Text - Title
 */
export function Title(Owner, Text) {
  this.container = CreateDIV(Owner, 'wm-lightgrey-title', null, null, Text);
}
Components.Dialog.Objects.Title = Title;

/**
 * Subtitle class
 * @class Subtitle
 * @description Create a subtitle on a slide
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Text - Subtitle
 */
export function Subtitle(Owner, Text) {
  this.container = CreateDIV(Owner, 'wm-title', null, null, Text);
}
Components.Dialog.Objects.Subtitle = Subtitle;

/**
 * Label class
 * @class Label
 * @description Create a label on a slide
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Text - Subtitle
 */
export function Label(Owner, Text) {
  this.container = CreateDIV(Owner, 'label', null, null, Text);
}
Components.Dialog.Objects.Label = Label;

/**
 * Show label
 * @method show
 * @memberof Components.Dialog.Objects.Label#
 */
Label.prototype.show = function () {
  this.container.style.display = 'block';
};
/**
 * Hide label
 * @method hide
 * @memberof Components.Dialog.Objects.Label#
 */
Label.prototype.hide = function () {
  this.container.style.display = 'none';
};

/**
 * Select class
 * @class Select
 * @description Create a pulldown on a slide
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {object} Options - Options of the pulldown (each option consists of a Value, Text and Selected property)
 * @param {boolean} Reset - Indicator if select must be reset
 * @callback [Callback] - Callback function after change in select (optional)
 */
export function Select(Owner, Options, Reset, Callback) {
  var _self = this;

  // CONTAINER
  this.container = CreateDIV(Owner, 'wm-select');

  // LABEL
  var lblSelect = CreateLabel(this.container, 'select-general');

  // CREATE SELECT
  this.selSelect = CreateSelect(lblSelect, null, null, null, function (a, e) {
    if (_self.selSelect.value.toString() !== '-1') {
      if (Callback !== undefined) {
        Callback();
      }

      if (Options[_self.selSelect.selectedIndex].Callback !== undefined) {
        Options[_self.selSelect.selectedIndex].Callback();
      }
      if (Reset) {
        _self.selSelect.selectedIndex = 0;
      }
    }
  });

  // ADD OPTIONS
  Options.forEach(function (o) {
    var selected = o.Selected !== undefined ? o.Selected : false;
    CreateOption(_self.selSelect, o.Value, o.Text, null, selected);
  });
}
Components.Dialog.Objects.Select = Select;

/**
 * Show select
 * @method show
 * @memberof Components.Dialog.Objects.Select#
 */
Select.prototype.show = function () {
  this.container.style.display = 'block';
};

/**
 * Show select
 * @method hide
 * @memberof Components.Dialog.Objects.Select#
 */
Select.prototype.hide = function () {
  this.container.style.display = 'none';
};

/**
 * return selected value
 * @method value
 * @returns {string}
 * @memberof Components.Dialog.Objects.Select#
 */
Select.prototype.value = function () {
  return this.selSelect.value;
};

/**
 * TextArea class
 * @class TextArea
 * @description Create a text area element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} PlaceholderText - Placeholder text of text area
 * @param {string} Text - Text of the text area
 * @returns {object}
 */
export function TextArea(Owner, PlaceholderText, Text) {
  this.container = CreateDIV(Owner, 'wm-textarea');
  this.taText = CreateTextArea(
    this.container,
    'wm-textarea',
    null,
    null,
    null,
    null,
    PlaceholderText,
    Text
  );
  return this;
}
Components.Dialog.Objects.TextArea = TextArea;

/**
 * Returns text in text area
 * @method value
 * @returns {string}
 * @memberof Components.Dialog.Objects.TextArea#
 */
TextArea.prototype.value = function () {
  return this.taText.value;
};
/**
 * Place text in text area
 * @setValue value
 * @param {string} value - Value to be placed in the Textarea object
 * @memberof Components.Dialog.Objects.TextArea#
 */
TextArea.prototype.setValue = function (value) {
  this.taText.value = value;
};

/**
 * Input class
 * @class Input
 * @description Create an input element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Placeholder - Placeholder text
 * @param {InitValue} InitValue - Initial value
 * @callback [Callback] - Callback function to be executed after enter is pressed (optional)
 */
export function Input(Owner, Placeholder, InitValue, Callback) {
  this.container = CreateDIV(Owner, 'wm-name-input');
  this.inpText = CreateInputText(
    this.container,
    null,
    null,
    null,
    Placeholder,
    InitValue
  );

  if (Callback !== void 0) {
    this.inpText.addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        Callback();
      }
    });
  }
}
Components.Dialog.Objects.Input = Input;

/**
 * Returns text in input
 * @method value
 * @returns {string}
 * @memberof Components.Dialog.Objects.Input#
 */
Input.prototype.value = function () {
  return this.inpText.value;
};

/**
 * Input numeric class
 * @class InputNumeric
 * @description Create an input element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Placeholder - Placeholder text
 * @param {InitValue} InitValue - Initial value
 * @callback [Callback] - Callback function to be executed after enter is pressed (optional)
 */
export function InputNumeric(Owner, Placeholder, InitValue, Callback) {
  this.container = CreateDIV(Owner, 'wm-name-input');
  this.inpText = CreateInputText(
    this.container,
    null,
    null,
    null,
    Placeholder,
    InitValue
  );

  this.inpText.onkeypress = function (e) {
    var charTyped = String.fromCharCode(e.which);
    var letterRegex = /[^0-9]/;
    return !charTyped.match(letterRegex);
  };

  if (Callback !== void 0) {
    this.inpText.addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        Callback();
      }
    });
  }
}
Components.Dialog.Objects.InputNumeric = InputNumeric;

/**
 * Returns text in input
 * @method value
 * @returns {string}
 * @memberof Components.Dialog.Objects.InputNumeric#
 */
InputNumeric.prototype.value = function () {
  return this.inpText.value;
};

/**
 * AddInput class
 * @class AddInput
 * @description Create an input element with a button to add the entered value to another object
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Placeholder - Placeholder text
 * @callback AddFunction - Callback function to be executed after enter the button is pressed
 */
export function AddInput(Owner, Placeholder, AddFunction) {
  this.container = CreateDIV(Owner, 'wm-create-new-group');

  CreateInputText(this.container, null, null, null, Placeholder);

  var divAddButton = CreateDIV(
    this.container,
    'add-btn',
    null,
    null,
    null,
    AddFunction
  );
  createElement('i', divAddButton, 'fa fa-plus');
}
Components.Dialog.Objects.AddInput = AddInput;

/**
 * MultiSelect class
 * @class MultiSelect
 * @description Create a multiselect element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {object} Options - Options to be placed in the multi select (each option consists of a Value, Text and Selected property)
 */
export function MultiSelect(Owner, Options) {
  var _self = this;

  this.scrollCounter = 1;
  this.optionsVisible = 0;

  //this.cbItems = [];
  this.originalOptions = Options;
  this.options = Options;

  // CONTAINER
  this.container = CreateDIV(Owner, 'wm-checkbox-list');
  this.container.addEventListener('scroll', function () {
    if (
      _self.container.scrollTop >
      _self.scrollCounter * _self.container.offsetHeight
    ) {
      _self.scrollCounter++;
      _self.addOptions();
    }
  });

  // UL LIST
  this.ulItems = CreateUL(this.container);

  // ADD OPTIONS
  if (this.options !== null) {
    this.addOptions();
  }
}
Components.Dialog.Objects.MultiSelect = MultiSelect;

/**
 * Add options to multi select list
 * @method addOptions
 * @memberof Components.Dialog.Objects.MultiSelect#
 */
MultiSelect.prototype.addOptions = function () {
  var _self = this;

  var oldNrOptions = this.optionsVisible;
  var newNrOptions = this.optionsVisible + 100;

  newNrOptions =
    newNrOptions > this.options.length ? this.options.length : newNrOptions;

  var tmpOptions = [];
  for (var i = oldNrOptions; i < newNrOptions; i++) {
    tmpOptions.push(this.options[i]);
  }

  this.optionsVisible = newNrOptions;

  // ADD LI ITEMS TO UL
  tmpOptions.forEach(function (o) {
    var liItem = CreateLI(_self.ulItems);
    var divCheckbox = CreateDIV(liItem, 'wm-cb');
    var lblCheckbox = CreateLabel(divCheckbox, 'checkbox');
    var cb = CreateInputCheck(
      lblCheckbox,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          o.Checked = cb.checked;
        }
      },
      null,
      o.Value
    );
    cb.checked = o.Checked;
    //if (o.Id !== undefined) {
    //    cb.id = o.Id;
    //}
    CreateSPAN(lblCheckbox);

    //_self.cbItems.push(cb);

    CreateDIV(liItem, 'wm-cb-list-groupname', null, null, o.Text);
  });
};

/**
 * Clears de options
 * @method clearOptions
 * @memberof Components.Dialog.Objects.MultiSelect#
 */
MultiSelect.prototype.clearOptions = function () {
  this.ulItems.innerHTML = '';
  this.scrollCounter = 1;
  this.container.scrollTop = 0;
  this.optionsVisible = 0;
};

/**
 * Returns the checked options of the multiselect
 * @method getCheckedOptions
 * @returns {Array.<Object>}
 * @memberof Components.Dialog.Objects.MultiSelect#
 */
MultiSelect.prototype.getCheckedOptions = function () {
  return this.originalOptions.filter(function (o) {
    return o.Checked;
  });
};

/**
 * Returns the original 'options' object
 * @method getOriginalOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.MultiSelect#
 */
MultiSelect.prototype.getOriginalOptions = function () {
  return this.originalOptions;
};
/**
 * Returns the 'options' object
 * @method getOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.MultiSelect#
 */
MultiSelect.prototype.getOptions = function () {
  return this.options;
};
/**
 * Sets the 'options' object
 * @method setOptions
 * @memberof Components.Dialog.Objects.MultiSelect#
 */
MultiSelect.prototype.setOptions = function (value) {
  this.options = value;
};

/**
 * MultiSelectAdd class
 * @class MultiSelectAdd
 * @description Create a multiselect element with an input field and 'add' button
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {object} Options - Options to be placed in the multi select (each option consists of a Value, Text and Selected property)
 * @param {string} Placeholder - Placeholder text in the input field
 * @callback AddFunction - Callback function after clicking the '+' button
 */
export function MultiSelectAdd(Owner, Options, Placeholder, AddFunction) {
  var _self = this;

  this.scrollCounter = 1;
  this.optionsVisible = 0;

  this.cbItems = [];
  this.originalOptions = Options;
  this.options = Options;

  // CONTAINER
  this.container = CreateDIV(Owner);

  // CHECKBOX CONTAINER
  this.divContainerCB = CreateDIV(this.container, 'wm-checkbox-list');
  this.divContainerCB.addEventListener('scroll', function () {
    //if (_self.container.scrollTop > _self.scrollCounter * _self.container.offsetHeight) {
    if (
      _self.divContainerCB.scrollTop >
      _self.scrollCounter * _self.divContainerCB.offsetHeight
    ) {
      _self.scrollCounter++;
      _self.addOptions();
    }
  });

  // UL LIST
  this.ulItems = CreateUL(this.divContainerCB);

  // ADD OPTIONS
  if (this.options !== null) {
    this.addOptions();
  }

  // BUTTON CONTAINER
  var divContainer = CreateDIV(this.container, 'wm-create-new-group');

  // INPUT ELEMENT
  var inpText = CreateInputText(divContainer, null, null, null, Placeholder);

  // ADD BUTTON
  var divAddButton = CreateDIV(
    divContainer,
    'add-btn',
    null,
    null,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        if (inpText.value.trim() !== '') {
          AddFunction(inpText.value, function (Team) {
            var liItem = CreateLI(_self.ulItems);
            var divCheckbox = CreateDIV(liItem, 'wm-cb');
            var lblCheckbox = CreateLabel(divCheckbox, 'checkbox');
            var cb = CreateInputCheck(lblCheckbox, null, null, null, Team.Id);
            cb.checked = true;
            CreateSPAN(lblCheckbox);
            CreateDIV(liItem, 'wm-cb-list-groupname', null, null, Team.Name);

            _self.cbItems.unshift(cb);
            inpText.value = '';

            _self.divContainerCB.scrollTop = _self.divContainerCB.scrollHeight;
          });
        }
      }
    }
  );
  createElement('i', divAddButton, 'fa fa-plus');
}
Components.Dialog.Objects.MultiSelectAdd = MultiSelectAdd;

/**
 * Add options to multi select list
 * @method addOptions
 * @memberof Components.Dialog.Objects.MultiSelectAdd#
 */
MultiSelectAdd.prototype.addOptions = function () {
  var _self = this;

  var oldNrOptions = this.optionsVisible;
  var newNrOptions = this.optionsVisible + 100;

  newNrOptions =
    newNrOptions > this.options.length ? this.options.length : newNrOptions;

  var tmpOptions = [];
  for (var i = oldNrOptions; i < newNrOptions; i++) {
    tmpOptions.push(this.options[i]);
  }

  this.optionsVisible = newNrOptions;

  // ADD LI ITEMS TO UL
  tmpOptions.forEach(function (o) {
    var liItem = CreateLI(_self.ulItems);
    var divCheckbox = CreateDIV(liItem, 'wm-cb');
    var lblCheckbox = CreateLabel(divCheckbox, 'checkbox');
    var cb = CreateInputCheck(
      lblCheckbox,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          o.Checked = cb.checked;
        }
      },
      null,
      o.Value
    );
    cb.checked = o.Checked;
    if (o.Id !== undefined) {
      cb.id = o.Id;
    }
    CreateSPAN(lblCheckbox);

    _self.cbItems.push(cb);

    CreateDIV(liItem, 'wm-cb-list-groupname', null, null, o.Text);
  });
};

/**
 * Clears de options
 * @method clearOptions
 * @memberof Components.Dialog.Objects.MultiSelectAdd#
 */
MultiSelectAdd.prototype.clearOptions = function () {
  this.ulItems.innerHTML = '';
  this.scrollCounter = 1;
  this.divContainerCB.scrollTop = 0;
  this.optionsVisible = 0;
};

/**
 * Get the checkbox elements from the multi select
 * @method getItems
 * @returns {Array.<object>}
 * @memberof Components.Dialog.Objects.MultiSelectAdd#
 */
MultiSelectAdd.prototype.getItems = function () {
  return this.cbItems;
};
/**
 * Returns the original 'options' object
 * @method getOriginalOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.MultiSelectAdd#
 */
MultiSelectAdd.prototype.getOriginalOptions = function () {
  return this.originalOptions;
};
/**
 * Returns the 'options' object
 * @method getOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.MultiSelectAdd#
 */
MultiSelectAdd.prototype.getOptions = function () {
  return this.options;
};
/**
 * Sets the 'options' object
 * @method setOptions
 * @memberof Components.Dialog.Objects.MultiSelectAdd#
 */
MultiSelectAdd.prototype.setOptions = function (value) {
  this.options = value;
};

/**
 * CheckboxLabel class
 * @class CheckboxLabel
 * @description Create a checkbox with al label
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} CheckboxText - Text shown next to the checkbox
 * @param {boolean} Checked - Indicator if the checkbox is checked
 */
export function CheckboxLabel(Owner, CheckboxText, Checked) {
  this.container = CreateDIV(Owner, 'wm-automatic-mail');

  var divCheckbox = CreateDIV(this.container, 'wm-cb');
  var lblCheckbox = CreateLabel(divCheckbox, 'checkbox');
  this.chkCheckbox = CreateInputCheck(lblCheckbox);
  this.chkCheckbox.checked = Checked !== undefined ? Checked : false;
  CreateSPAN(lblCheckbox);

  CreateDIV(this.container, 'wm-cb-text', null, null, CheckboxText);
}
Components.Dialog.Objects.CheckboxLabel = CheckboxLabel;

/**
 * Returns the checked status of the checkbox
 * @method checked
 * @returns {boolean}
 * @memberof Components.Dialog.Objects.CheckboxLabel#
 */
CheckboxLabel.prototype.checked = function () {
  return this.chkCheckbox.checked;
};

/**
 * EditListInput class
 * @class EditListInput
 * @description Create an list where items can edited and deleted
 * @memberof Components.Dialog.Objects
 * @param {object} ListItems -Object with the list items
 * @callback SaveFunction - Callback function when the save button is pressed
 * @callback DeleteFunction - Callback function when the delete button is pressed
 * @param {object} ConfirmDialogText - Object containing the text of the confirm dialog
 */
export function EditListInput(
  ListItems,
  SaveFunction,
  DeleteFunction,
  ConfirmDialogText
) {
  var _self = this;

  // CONTAINER
  this.container = CreateDIV(null, 'editable-list');

  // LIST ITEMS
  var listEditableItems = [];
  ListItems.forEach(function (li) {
    // *** LIST ITEM
    // LIST ITEM CONTAINER
    var divListItem = CreateDIV(
      _self.container,
      'editable-list-item',
      null,
      'eli_' + li.Id
    );

    // RADIO BUTTON
    var divRadioButton = CreateDIV(divListItem, 'radiobtn-filter-preset');
    var optRadio = CreateInputRadio(
      divRadioButton,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          listEditableItems.forEach(function (ei) {
            ei.classList.remove('editable');
          });
          divEditableItem.classList.add('editable');
          inpEditableItem.focus();
        }
      },
      null,
      null,
      null,
      'rb_' + li.Id
    );
    optRadio.addEventListener('blur', function () {
      //divEditableItem.classList.remove("editable");
    });
    var lblRadio = CreateLabel(divRadioButton, null, 'rb_' + li.Id);
    CreateSPAN(lblRadio, 'p5 fa fa-pencil');

    // EDITABLE ITEM
    var divEditableItem = CreateDIV(
      divListItem,
      'editable-item',
      null,
      'ei_' + li.Id
    );

    // ADD ITEM TO ARRAY
    listEditableItems.push(divEditableItem);

    var oldName = li.Name;
    var inpEditableItem = CreateInputText(
      divEditableItem,
      null,
      null,
      null,
      null,
      li.Name
    );
    inpEditableItem.addEventListener('keyup', function (event) {
      if (event.keyCode === 13 && inpEditableItem.value.trim() !== '') {
        event.preventDefault();
        SaveFunction(li.Id, inpEditableItem.value);
        oldName = inpEditableItem.value;

        divEditableItem.classList.remove('editable');
        inpEditableItem.blur();
      }
    });

    // SAVE BUTTON
    var divSaveBtn = CreateDIV(
      divEditableItem,
      'eli-icon',
      null,
      null,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          if (inpEditableItem.value.trim() !== '') {
            SaveFunction(li.Id, inpEditableItem.value);
            oldName = inpEditableItem.value;

            divEditableItem.classList.remove('editable');
          }
        }
      }
    );
    createElement('i', divSaveBtn, 'fa fa-check _if-green');

    // CANCEL BUTTON
    var divCancelBtn = CreateDIV(
      divEditableItem,
      'eli-icon',
      null,
      null,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          divEditableItem.classList.remove('editable');
          inpEditableItem.value = oldName;
        }
      }
    );
    createElement('i', divCancelBtn, 'fa fa-times _if-red');

    // DELETE BUTTON
    var divTrashBtn = CreateDIV(
      divEditableItem,
      'eli-icon',
      null,
      null,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          // SHOW CONFIRM DIALOG
          _self.slide.modal.createConfirmModal(
            ConfirmDialogText.Title,
            ConfirmDialogText.ConfirmButtonText,
            ConfirmDialogText.CancelButtonText,
            function () {
              DeleteFunction(li.Id);
              divEditableItem.classList.remove('editable');

              for (var i = 0; i < listEditableItems.length; i++) {
                if (listEditableItems[i].id === divEditableItem.id) {
                  listEditableItems.splice(i, 1);
                  divListItem.parentElement.removeChild(divListItem);
                  break;
                }
              }
              _self.slide.modal.divConfirm.style.display = 'none';
            }
          );
        }
      }
    );
    createElement('i', divTrashBtn, 'fa fa-trash-o');
  });
}
Components.Dialog.Objects.EditListInput = EditListInput;

/**
 * Set the slide the list belongs to
 * @method setSlide
 * @memberof Components.Dialog.Objects.EditListInput#
 */
EditListInput.prototype.setSlide = function (value) {
  this.slide = value;
};

/**
 * SearchBox class
 * @class SearchBox
 * @description Create a search box
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Placeholder - Placeholder text
 * @callback Callback - Callback function when the search button or enter is pressed in th einput field
 */
export function SearchBox(Owner, Placeholder, Callback) {
  // MAIN CONTAINER
  this.container = CreateDIV(Owner, 'wizard-search');

  // CONTAINER
  var divSBContainer = CreateDIV(this.container, 'sb-cntnr');
  // INPUT
  this.inpSearch = CreateInputText(
    divSBContainer,
    null,
    null,
    null,
    Placeholder
  );
  // ADD EVENT LISTENER
  this.inpSearch.addEventListener('keyup', function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (Callback !== null && Callback !== undefined) {
        Callback();
      }
    }
  });
  // SEARCH BUTTON
  var divSBButton = CreateDIV(
    divSBContainer,
    'sb-btn-f',
    null,
    null,
    null,
    function (a, e) {
      if (a === MouseActionType.Click) {
        if (Callback !== null && Callback !== undefined) {
          Callback();
        }
      }
    }
  );

  createElement('i', divSBButton, 'fa fa-search');
}
Components.Dialog.Objects.SearchBox = SearchBox;

/**
 * Returns the value of the input
 * @method value
 * @returns {string}
 * @memberof Components.Dialog.Objects.SearchBox#
 */
SearchBox.prototype.value = function () {
  return this.inpSearch.value;
};

/**
 * CheckBox class
 * @class CheckBox
 * @description Create a checkbox
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @callback Callback - Callback function when the checkbox is (un)checked
 */
export function CheckBox(Owner, Callback) {
  // MAIN CONTAINER
  this.container = CreateDIV(Owner, 'label');

  // CHECKBOX CONTAINER
  var divCheckBox = CreateLabel(this.container, 'checkbox');
  divCheckBox.style.cssText = 'transform:scale(.7)';

  // CHECKBOX
  this.chkBox = CreateInputCheck(divCheckBox);
  this.chkBox.onchange = function () {
    if (Callback !== null && Callback !== undefined) {
      Callback();
    }
  };
  CreateSPAN(divCheckBox);
}
Components.Dialog.Objects.CheckBox = CheckBox;

/**
 * Returns the checked status of the checkbox
 * @method isChecked
 * @returns {string}
 * @memberof Components.Dialog.Objects.CheckBox#
 */
CheckBox.prototype.isChecked = function () {
  return this.chkBox.checked;
};

/**
 * Image upload class
 * @class ImageUpload
 * @description Create an image upload element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 */
export function ImageUpload(Owner, imgId) {
  var _self = this;
  this.blnImgLoaded = false;

  //this.imgData = [];
  this.imgData = {
    Base64Data: null,
    Name: null,
  };

  // CONTAINER
  this.container = CreateDIV(Owner, 'iu-container');

  // IMAGE
  var imgUpload = CreateImage(this.container);
  if (imgId) {
    imgUpload.id = imgId;
  }

  // FILE INPUT
  var inpImage = CreateInputFile(this.container);
  inpImage.addEventListener('change', function () {
    var f = inpImage.files[0];
    if (!f) {
      getTop().hidesave();
      return;
    }
    _self.imgData.Name = inpImage.files[0].name;

    var reader = new FileReader();
    reader.addEventListener(
      'load',
      function () {
        _self.imgData.Base64Data = reader.result;
        imgUpload.src = reader.result;
        _self.blnImgLoaded = true;
      },
      false
    );
    if (f) {
      reader.readAsDataURL(f);
    }
  });
}
Components.Dialog.Objects.ImageUpload = ImageUpload;

/**
 * Returns the image data (base64 encoded data + filename)
 * @method getImageData
 * @returns {object}
 * @memberof Components.Dialog.Objects.ImageUpload#
 */
ImageUpload.prototype.getImageData = function () {
  return this.imgData;
};
/**
 * Returns if image is loaded
 * @method imageLoaded
 * @returns {boolean}
 * @memberof Components.Dialog.Objects.ImageUpload#
 */
ImageUpload.prototype.imageLoaded = function () {
  return this.blnImgLoaded;
};

/**
 * DatePicker class
 * @class DatePicker
 * @description Create a datepicker
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {string} Id - ID of element
 * @param {date} DefaultValue - Default date
 * @param {function} OnChange - Function executed when date is changed
 * @param {function} SetDefault - Function to reset date to default value
 * @param {string} DateLabel - Text of label next to datepicker
 */
export function DatePicker(
  Owner,
  Id,
  DefaultValue,
  OnChange,
  SetDefault,
  DateLabel
) {
  this.setDefault = SetDefault;
  this.id = Id;
  this.onChange = OnChange;

  this.container = CreateDIV(
    Owner,
    'content-filter modal-date-picker',
    'width: 100%; float: left; padding: 16px 0 8px 0; line-height: normal; fonts-size: 14px;'
  );

  CreateDIV(this.container, null, null, null, DateLabel);

  var divDate = CreateDIV(
    this.container,
    'filter-item calendar-icon',
    'width: 100%;'
  );
  var inpDate = CreateInputText(divDate);
  inpDate.id = Id;

  this.fp = flatpickr('#' + Id, {
    altInput: true,
    altFormat: 'd-m-Y',
    dateFormat: 'Y-m-d',
    locale: {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: lang.generic.weekdays_short.split(','),
        longhand: lang.generic.weekdays.split(','),
      },
      months: {
        shorthand: lang.generic.monthnames_short.split(','),
        longhand: lang.generic.monthnames.split(','),
      },
    },
  });
  this.fp.altInput.classList.add('flatpickr');
}
Components.Dialog.Objects.DatePicker = DatePicker;

/**
 * Set date of datepicker
 * @method setDate
 * @memberof Components.Dialog.Objects.DatePicker#
 */
DatePicker.prototype.setDate = function (date) {
  this.fp.setDate(date);
};
/**
 * Return alt value of datepicker
 * @method altInputValue
 * @memberof Components.Dialog.Objects.DatePicker#
 */
DatePicker.prototype.altInputValue = function () {
  return this.fp.altInput.value;
};
/**
 * Return date value of datepicker
 * @method selectedDate
 * @memberof Components.Dialog.Objects.DatePicker#
 */
DatePicker.prototype.selectedDate = function () {
  return this.fp.selectedDates[0];
};

/**
 * List class
 * @class List
 * @description Create a list element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {object} Options - Options to be placed in the list(each option consists of a Text property)
 */
export function List(Owner, Options) {
  var _self = this;

  this.scrollCounter = 1;
  this.optionsVisible = 0;

  this.options = Options;
  this.originalOptions = Options;

  // CONTAINER
  this.container = CreateDIV(Owner, 'wm-checkbox-list');
  this.container.addEventListener('scroll', function () {
    if (
      _self.container.scrollTop >
      _self.scrollCounter * _self.container.offsetHeight
    ) {
      _self.scrollCounter++;
      _self.addOptions();
    }
  });

  // UL LIST
  this.ulItems = CreateUL(this.container);

  // ADD LI ITEMS TO UL
  if (this.options !== null) {
    this.addOptions();
  }
}
Components.Dialog.Objects.List = List;

/**
 * Add options to multi select list
 * @method addOptions
 * @memberof Components.Dialog.Objects.List#
 */
List.prototype.addOptions = function () {
  var _self = this;

  var oldNrOptions = this.optionsVisible;
  var newNrOptions = this.optionsVisible + 100;

  newNrOptions =
    newNrOptions > this.options.length ? this.options.length : newNrOptions;

  var tmpOptions = [];
  for (var i = oldNrOptions; i < newNrOptions; i++) {
    tmpOptions.push(this.options[i]);
  }

  this.optionsVisible = newNrOptions;

  // ADD LI ITEMS TO UL
  tmpOptions.forEach(function (o) {
    var liItem = CreateLI(_self.ulItems);
    CreateDIV(liItem, 'wm-no-cb-li', null, null, o.Text);
  });
};

/**
 * Clears de options
 * @method clearOptions
 * @memberof Components.Dialog.Objects.List#
 */
List.prototype.clearOptions = function () {
  this.ulItems.innerHTML = '';
  this.scrollCounter = 1;
  this.container.scrollTop = 0;
  this.optionsVisible = 0;
};

/**
 * Returns the original 'options' object
 * @method getOriginalOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.List#
 */
List.prototype.getOriginalOptions = function () {
  return this.originalOptions;
};
/**
 * Returns the 'options' object
 * @method getOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.List#
 */
List.prototype.getOptions = function () {
  return this.options;
};
/**
 * Sets the 'options' object
 * @method setOptions
 * @memberof Components.Dialog.Objects.List#
 */
List.prototype.setOptions = function (value) {
  this.options = value;
};

/**
 * List double row class
 * @class ListDoubleRow
 * @description Create a multiselect element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {object} Options - Options to be placed in the multi select (each option consists of a Value, Text1, Text2 and Selected property)
 */
export function ListDoubleRow(Owner, Options) {
  var _self = this;

  this.scrollCounter = 1;
  this.optionsVisible = 0;

  this.options = Options;
  this.originalOptions = Options;

  // CONTAINER
  this.container = CreateDIV(Owner, 'wm-checkbox-list');

  this.container.addEventListener('scroll', function () {
    if (
      _self.container.scrollTop >
      _self.scrollCounter * _self.container.offsetHeight
    ) {
      _self.scrollCounter++;
      _self.addOptions();
    }
  });

  // UL LIST
  this.ulItems = CreateUL(this.container);

  // ADD OPTIONS
  if (this.options !== null) {
    this.addOptions();
  }
}
Components.Dialog.Objects.ListDoubleRow = ListDoubleRow;

/**
 * Add options to multi select list
 * @method addOptions
 * @memberof Components.Dialog.Objects.ListDoubleRow#
 */
ListDoubleRow.prototype.addOptions = function () {
  var _self = this;

  var oldNrOptions = this.optionsVisible;
  var newNrOptions = this.optionsVisible + 100;

  newNrOptions =
    newNrOptions > this.options.length ? this.options.length : newNrOptions;

  var tmpOptions = [];
  for (var i = oldNrOptions; i < newNrOptions; i++) {
    tmpOptions.push(this.options[i]);
  }

  this.optionsVisible = newNrOptions;

  // ADD LI ITEMS TO UL
  tmpOptions.forEach(function (o) {
    var liItem = CreateLI(_self.ulItems);

    CreateDIV(liItem, 'wm-cb-dl-item1', null, null, o.Text1);
    CreateDIV(liItem, 'wm-cb-dl-item2', null, null, o.Text2);
  });
};

/**
 * Clears de options
 * @method clearOptions
 * @memberof Components.Dialog.Objects.ListDoubleRow#
 */
ListDoubleRow.prototype.clearOptions = function () {
  this.ulItems.innerHTML = '';
  this.scrollCounter = 1;
  this.container.scrollTop = 0;
  this.optionsVisible = 0;
};

/**
 * Returns the original 'options' object
 * @method getOriginalOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.ListDoubleRow#
 */
ListDoubleRow.prototype.getOriginalOptions = function () {
  return this.originalOptions;
};
/**
 * Returns the 'options' object
 * @method getOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.ListDoubleRow#
 */
ListDoubleRow.prototype.getOptions = function () {
  return this.options;
};
/**
 * Sets the 'options' object
 * @method setOptions
 * @memberof Components.Dialog.Objects.ListDoubleRow#
 */
ListDoubleRow.prototype.setOptions = function (value) {
  this.options = value;
};

/**
 * MultiSelect double row class
 * @class MultiSelectDoubleRow
 * @description Create a multiselect double row element
 * @memberof Components.Dialog.Objects
 * @param {object} Owner - HTML DOM element
 * @param {object} Options - Options to be placed in the multi select (each option consists of a Value, Text1, Text2 and Selected property)
 */
export function MultiSelectDoubleRow(Owner, Options) {
  var _self = this;

  this.scrollCounter = 1;
  this.optionsVisible = 0;

  this.originalOptions = Options;
  this.options = Options;

  // CONTAINER
  this.container = CreateDIV(Owner, 'wm-checkbox-list');
  this.container.addEventListener('scroll', function () {
    if (
      _self.container.scrollTop >
      _self.scrollCounter * _self.container.offsetHeight
    ) {
      _self.scrollCounter++;
      _self.addOptions();
    }
  });

  // UL LIST
  this.ulItems = CreateUL(this.container);

  // ADD OPTIONS
  if (this.options !== null) {
    this.addOptions();
  }
}
Components.Dialog.Objects.MultiSelectDoubleRow = MultiSelectDoubleRow;

/**
 * Add options to multi select list
 * @method addOptions
 * @memberof Components.Dialog.Objects.MultiSelectDoubleRow#
 */
MultiSelectDoubleRow.prototype.addOptions = function () {
  var _self = this;

  var oldNrOptions = this.optionsVisible;
  var newNrOptions = this.optionsVisible + 100;

  newNrOptions =
    newNrOptions > this.options.length ? this.options.length : newNrOptions;

  var tmpOptions = [];
  for (var i = oldNrOptions; i < newNrOptions; i++) {
    tmpOptions.push(this.options[i]);
  }

  this.optionsVisible = newNrOptions;

  // ADD LI ITEMS TO UL
  tmpOptions.forEach(function (o) {
    var liItem = CreateLI(_self.ulItems);
    var divCheckbox = CreateDIV(liItem, 'wm-cb');
    var lblCheckbox = CreateLabel(divCheckbox, 'checkbox');
    var cb = CreateInputCheck(
      lblCheckbox,
      null,
      function (a, e) {
        if (a === MouseActionType.Click) {
          o.Checked = cb.checked;

          for (var i = 0; i < _self.originalOptions.length; i++) {
            if (_self.originalOptions.Value === o.Value) {
              _self.originalOptions.Checked = o.Checked;
            }
          }
        }
      },
      null,
      o.Value
    );
    cb.checked = o.Checked;
    CreateSPAN(lblCheckbox);

    CreateDIV(liItem, 'wm-cb-dl-item1', null, null, o.Text1);
    CreateDIV(liItem, 'wm-cb-dl-item2', null, null, o.Text2);
  });
};
/**
 * Returns the checkbox elements of the multiselect
 * @method clearOptions
 * @memberof Components.Dialog.Objects.MultiSelectDoubleRow#
 */
MultiSelectDoubleRow.prototype.clearOptions = function () {
  this.ulItems.innerHTML = '';
  this.scrollCounter = 1;
  this.container.scrollTop = 0;
  this.optionsVisible = 0;
};

/**
 * Returns the checked options of the multiselect
 * @method getCheckedOptions
 * @returns {Array.<Object>}
 * @memberof Components.Dialog.Objects.MultiSelectDoubleRow#
 */
MultiSelectDoubleRow.prototype.getCheckedOptions = function () {
  return this.originalOptions.filter(function (o) {
    return o.Checked;
  });
};

/**
 * Returns the original 'options' object
 * @method getOriginalOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.MultiSelectDoubleRow#
 */
MultiSelectDoubleRow.prototype.getOriginalOptions = function () {
  return this.originalOptions;
};
/**
 * Returns the 'options' object
 * @method getOptions
 * @returns {Object}
 * @memberof Components.Dialog.Objects.MultiSelectDoubleRow#
 */
//MultiSelectDoubleRow.prototype.getOptions = function () {
//    return this.options;
//}
/**
 * Sets the 'options' object
 * @method setOptions
 * @memberof Components.Dialog.Objects.MultiSelectDoubleRow#
 */
MultiSelectDoubleRow.prototype.setOptions = function (value) {
  this.options = value;
};

window.Components = Components;
